export const formatNumberRangeDisplay = (
  placeholder: string,
  minValue?: number | null,
  maxValue?: number | null,
): string => {
  if (
    minValue !== undefined &&
    minValue !== null &&
    maxValue !== undefined &&
    maxValue !== null
  ) {
    return `${minValue} - ${maxValue}`;
  }

  if (minValue !== undefined && minValue !== null) {
    return `≥ ${minValue}`;
  }

  if (maxValue !== undefined && maxValue !== null) {
    return `≤ ${maxValue}`;
  }

  return placeholder;
};
